<template>
  <div ref="missionName" class="mission-name">
    <span>Misja:</span>
    <p>
      {{missionName}}
      <span class="gamename">{{missionTitle}}</span>
    </p>
  </div>
</template>

<script>
import {TimelineLite} from "gsap";

export default {
  name: "MoleculeMissionName",
  props:[
      'missionName', 'missionTitle'
  ],
  mounted() {
    if (window.innerWidth > 800) {
      const timeline = new TimelineLite()
      const { missionName } = this.$refs
      const mute = document.getElementById('setup');
      timeline
          .to(mute,  {  x: 0, y:90,})
          .to(missionName,  { x: 0, y:100, rotation: 0 })
    }
  }

}
</script>
